import React, { useEffect } from 'react';
import StorelessState from './context/storelessState';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { SignupPage } from './pages/Signup/SignupPage';
import { SignupBrandAgencyPage } from './pages/Signup/SignupBrandAgencyPage';
import { SignupInfluencerPage } from './pages/Signup/SignupInfluencerPage';
import { SignInPage } from './pages/SignIn/SignInPage';
import { BrandOtpValidationPage } from './pages/Brand/BrandOtpValidationPage';
import { BrandHomePage } from './pages/Brand/BrandHomePage';
import { SignInBrandAgencyPage } from './pages/SignIn/SignInBrandAgencyPage';
import { SignInInfluencerPage } from './pages/SignIn/SignInInfluencerPage';
import { ProtectedRoute } from './components/Routes/ProtectedRoute';
import { useGlobalState } from './store/state';
// import { generate, presetDarkPalettes } from "@ant-design/colors";
// import "antd/dist/antd.css";
import BrandCampaignPage from './pages/Brand/BrandCampaignPage';
import BrandCreateCampaignPage from './pages/Brand/BrandCreateCampaignPage';
import { BrandCompanyPage } from './pages/Brand/BrandCompanyPage';
import './styles/custom-antd.css';
import './styles/index.scss';
import { tz } from 'moment-timezone';
import { BrandCreditPage } from './pages/Brand/BrandCreditPage';
import { BrandDiscoverPage } from './pages/Brand/BrandDiscoverPage';
import { BrandInfluencerListPage } from './pages/Brand/BrandInfluencerListPage';
import { BrandChatsPage } from './pages/Brand/BrandChatsPage';
import CreateCompanyPage from './pages/Brand/CreateCompanyPage';
import { SigninBrandResetPasswordPage } from './pages/SignIn/SigninBrandResetPasswordPage';
import BrandStatsPage from './pages/Brand/BrandStatsPage';
import BrandStatsDetailPage from './pages/Brand/BrandStatsDetailPage';

import { InfluencerHomePage } from './pages/Influencer/InfluencerHomePage';
import { InfluencerOtpValidationPage } from './pages/Influencer/InfluencerOtpValidationPage';
import InfluencerCampaignPage from './pages/Influencer/InfluencerCampaignPage';
import { InfluencerChatsPage } from './pages/Influencer/InfluencerChatsPage';
import { BrandInfluencerProfilePage } from './pages/Brand/BrandInfluencerProfilePage';
import { SigninInfluencerResetPasswordPage } from './pages/SignIn/SigninInfluencerResetPasswordPage';
import InfluencerCampaignDetailsPage from './pages/Influencer/InfluencerCampaignDetailsPage';
import { Config } from './Config';
import InfluencerCampaignCreativesPage from './pages/Influencer/InfluencerCampaignCreativesPage';
import { InfluencerWalletPage } from './pages/Influencer/InfluencerWalletPage';
import { InfluencerProfilePage } from './pages/Influencer/InfluencerProfilePage';
import InfluencerCampaignCreativeViewPage from './pages/Influencer/InfluencerCampaignCreativeViewPage';
import { InfluencerStatsPage } from './pages/Influencer/InfluencerStatsPage';
import { SignupAdminPage } from './pages/Signup/SignupAdminPage';
import { AdminHomePage } from './pages/Admin/AdminHomePage';
import { SignInAdminPage } from './pages/SignIn/SignInAdminPage';
import { SigninAdminResetPasswordPage } from './pages/SignIn/SigninAdminResetPasswordPage';
import { AdminFinancePage } from './pages/Admin/AdminFinancePage';
import { AdminBrandsPage } from './pages/Admin/AdminBrandsPage';
import { AdminInfluencersPage } from './pages/Admin/AdminInfluencersPage';
import { AdminCampaignsPage } from './pages/Admin/AdminCampaignsPage';
import BrandCampaignDetailsPage from './pages/Brand/BrandCampaignDetailsPage';
import { AdminInfluencersDetailPage } from './pages/Admin/AdminInfluencersDetailPage';
import AdminCampaignDetailsPage from './pages/Admin/AdminCampaignDetailsPage';
import { AdminBrandsCompaniesPage } from './pages/Admin/AdminBrandsCompaniesPage';
import { AdminBrandsCompaniesDetailPage } from './pages/Admin/AdminBrandsCompaniesDetailPage';
import AdminCreateCampaignPage from './pages/Admin/AdminCreateCampaignPage';
import AdminInfluencerListPage from './pages/Admin/AdminInfluencerListPage';
import AdminBrandListPage from './pages/Admin/AdminBrandListPage';
// tz.setDefault(Config.timezone || "Atlantic/Reykjavik");
function App () {
  const [user] = useGlobalState('user');
  // const [company] = useGlobalState("company");
  // useEffect(() => {
  // }, []);
  return (
    <div className="App">
      <StorelessState>
        <Router
        // basename={process.env.REACT_APP_MODE === "prod" ? "/app-demo" : ""}
        >
          <Switch>
            <Route exact
              path="/"
              component={SignInPage} />
            <Route exact
              path="/signup"
              component={SignupPage} />
            <Route
              exact
              path="/signup/brand-agency"
              component={SignupBrandAgencyPage}
            />
            <Route
              exact
              path="/signup/influencer"
              component={SignupInfluencerPage}
            />
            <Route exact
              path="/signin"
              component={SignInPage} />
            <Route
              exact
              path="/signin/brand-agency"
              component={SignInBrandAgencyPage}
            />
            <Route
              exact
              path="/signin/influencer"
              component={SignInInfluencerPage}
            />

            {/* brand related pages  */}
            <Route
              exact
              path="/signin/brand-agency/reset"
              component={SigninBrandResetPasswordPage}
            />
            <ProtectedRoute
              exact
              isSignedIn={user.accessToken}
              path="/brand/validate-otp"
              component={BrandOtpValidationPage}
            />
            <ProtectedRoute
              exact
              isSignedIn={user.accessToken}
              path="/brand/create-company"
              component={CreateCompanyPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand"
              state={{ activeMenu: 'brand' }}
              component={BrandHomePage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/stats"
              state={{ activeMenu: 'brand_campaign' }}
              component={BrandStatsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/stats/:campaignId"
              state={{ activeMenu: 'brand_campaign' }}
              component={BrandStatsDetailPage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/discover"
              state={{ activeMenu: 'brand_discovery' }}
              component={BrandDiscoverPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/discover/profile/:influencerId"
              state={{ activeMenu: 'brand_discovery' }}
              component={BrandInfluencerProfilePage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path={`/brand/:companyId`}
              state={{ activeMenu: 'brand' }}
              component={BrandCompanyPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/credit"
              state={{ activeMenu: 'brand_credit' }}
              component={BrandCreditPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/influencer-list"
              state={{ activeMenu: 'brand_influencer-list' }}
              component={BrandInfluencerListPage}
            />
            {/* <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/discover"
              state={{ activeMenu: "brand_campaign" }}
              component={BrandDiscoverPage}
            /> */}
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/chats"
              state={{ activeMenu: 'brand_chats' }}
              component={BrandChatsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/campaign"
              state={{ activeMenu: 'brand_campaign' }}
              component={BrandCampaignPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/campaign/:campaignId"
              state={{ activeMenu: 'brand_campaign' }}
              component={BrandCreateCampaignPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/brand/:companyId/campaign/:campaignId/details"
              state={{ activeMenu: 'brand_campaign' }}
              component={BrandCampaignDetailsPage}
            />

            {/* <Route exact path="/brand" component={BrandHomePage} /> */}

            {/* influencer related pages */}
            <Route
              exact
              path="/signin/influencer/reset"
              component={SigninInfluencerResetPasswordPage}
            />
            <ProtectedRoute
              exact
              isSignedIn={user.accessToken}
              path="/influencer/validate-otp"
              component={InfluencerOtpValidationPage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer"
              state={{ activeMenu: 'influencer' }}
              component={InfluencerStatsPage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/campaigns"
              state={{ activeMenu: 'influencer_campaigns' }}
              component={InfluencerCampaignPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/campaigns/:campaignId"
              state={{ activeMenu: 'influencer_campaigns' }}
              component={InfluencerCampaignDetailsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/campaigns/:campaignId/creatives"
              state={{ activeMenu: 'influencer_campaigns' }}
              component={InfluencerCampaignCreativesPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/campaigns/:campaignId/creatives/review"
              state={{ activeMenu: 'influencer_campaigns' }}
              component={InfluencerCampaignCreativeViewPage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/chats"
              state={{ activeMenu: 'influencer_chats' }}
              component={InfluencerChatsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/wallet"
              state={{ activeMenu: 'influencer_wallet' }}
              component={InfluencerWalletPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/profile"
              state={{ activeMenu: 'influencer' }}
              component={InfluencerProfilePage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/influencer/stats"
              state={{ activeMenu: 'influencer_stats' }}
              component={InfluencerStatsPage}
            />
            {/* <Route exact path="/influencer" component={InfluencerHomePage} /> */}

            {/* Admin pages */}
            <Route exact
              path="/admin"
              component={SignInAdminPage} />
            <Route exact
              path="/admin/register"
              component={SignupAdminPage} />
            <Route
              exact
              path="/admin/reset"
              component={SigninAdminResetPasswordPage}
            />

            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard"
              state={{ activeMenu: 'admin' }}
              component={AdminHomePage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/campaigns"
              state={{ activeMenu: 'admin_campaigns' }}
              component={AdminCampaignsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/campaigns/:campaignId"
              state={{ activeMenu: 'admin_campaigns' }}
              component={AdminCampaignDetailsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/influencers"
              state={{ activeMenu: 'admin_influencers' }}
              component={AdminInfluencersPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/influencers/:influencerId"
              state={{ activeMenu: 'admin_influencers' }}
              component={AdminInfluencersDetailPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/brands"
              state={{ activeMenu: 'admin_brands' }}
              component={AdminBrandsPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/brands/:brandId/companies"
              state={{ activeMenu: 'admin_brands' }}
              component={AdminBrandsCompaniesPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/brands/:brandId/companies/:companyId"
              state={{ activeMenu: 'admin_brands' }}
              component={AdminBrandsCompaniesDetailPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/dashboard/finance"
              state={{ activeMenu: 'admin_finance' }}
              component={AdminFinancePage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/campaign/create"
              state={{ activeMenu: 'admin_campaign' }}
              component={AdminCreateCampaignPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/influencer-list"
              state={{ activeMenu: 'admin_influencer_list' }}
              component={AdminInfluencerListPage}
            />
            <ProtectedRoute
              isSignedIn={user.accessToken}
              exact
              path="/admin/brand-list"
              state={{ activeMenu: 'admin_brand_list' }}
              component={AdminBrandListPage}
            />
          </Switch>
        </Router>
      </StorelessState>
    </div>
  );
}

export default App;
